import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Table, Row, Button, Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import { Link } from 'react-router-dom'
import ReconTableItem from './ReconTableItem'
import PageHeading from '../Shared/LayoutComponents/PageHeading'
import PageContainer from '../Shared/LayoutComponents/PageContainer'

const ReconCompany = (props) => {
  let pageSize = 10
  const [currentPage, setCurrentPage] = useState(0)
  let pagesCount = Math.ceil(props.selectedCompany && props.selectedCompany.reconciliations.length / pageSize)

  return (
    <PageContainer>
      <Row>
        <PageHeading small={true} fullWidth={true}>
          Reconciliations for {props.selectedCompany.name}
        </PageHeading>
      </Row>
      <div>
        <Pagination aria-label="Page navigation" style={{ float: 'right' }}>
          <PaginationItem disabled={currentPage <= 0}>
            <PaginationLink onClick={() => setCurrentPage(currentPage - 1)} previous href="#" />
          </PaginationItem>
          {[...Array(pagesCount)].map((page, i) => (
            <PaginationItem active={i === currentPage} key={i}>
              <PaginationLink onClick={() => setCurrentPage(i)} href="#">
                {i + 1}
              </PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem disabled={currentPage >= pagesCount - 1}>
            <PaginationLink onClick={() => setCurrentPage(currentPage + 1)} next href="#" />
          </PaginationItem>
        </Pagination>
        {props.isEssentialsSelected ? (
          <Link to="/essentialsReconciliation">
            <Button style={{ color: 'rgb(78, 85, 91)' }} color="link">
              Back to Companies
            </Button>
          </Link>
        ) : (
          <Link to="/reconciliation">
            <Button style={{ color: 'rgb(78, 85, 91)' }} color="link">
              Back to Companies
            </Button>
          </Link>
        )}
      </div>
      <Table>
        <thead>
          <tr>
            <th>Month</th>
            <th>Status</th>
            <th>Product Count</th>
            <th>Remaining Count</th>
            <th></th>
          </tr>
        </thead>
        {props.selectedCompany && props.selectedCompany.reconciliations.length === 0 ? (
          <tr>
            <td colSpan="6" style={{ textAlign: 'center', fontSize: '1.25rem' }}>
              No Reconciliations Found
            </td>
          </tr>
        ) : (
          <tbody>
            {props.selectedCompany.reconciliations
              .slice(currentPage * pageSize, currentPage * pageSize + pageSize)
              .map((recon, index) => (
                <ReconTableItem key={index} recon={recon} />
              ))}
          </tbody>
        )}
      </Table>
    </PageContainer>
  )
}

const mapStateToProps = (state) => ({
  selectedCompany: state.recon.selectedCompany,
  isEssentialsSelected: state.recon.isEssentialsSelected,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ReconCompany)
